import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Booking } from "./Booking";
import { CONTACT } from "@/lib/content";
import { WhatsAppIcon } from "./Icons";

export const SiteLayout = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
    } else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
        <Booking />
      </main>
      <Footer />
      <a
        href={CONTACT.waUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] text-white px-5 py-3 shadow-xl hover:scale-105 transition-transform"
      >
        <WhatsAppIcon className="w-5 h-5" />
        <span className="font-brand text-xs font-semibold tracking-[0.2em] uppercase hidden sm:inline">WhatsApp</span>
      </a>
    </div>
  );
};
